import React, { useState } from 'react';
import { Play, X } from 'lucide-react';

const VideoPlayer = ({ project, onClose }) => {
  const [isLoading, setIsLoading] = useState(true);

  if (!project || !project.youtubeId) {
    return null;
  }

  const embedUrl = `https://www.youtube.com/embed/${project.youtubeId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
  
  const isVertical = project.format === 'vertical';

  return (
    <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="relative w-full max-w-6xl">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 text-white hover:scale-110 transition-transform z-10"
          style={{ color: 'white' }}
          onMouseEnter={(e) => e.target.style.color = '#f97316'}
          onMouseLeave={(e) => e.target.style.color = 'white'}
        >
          <X className="h-8 w-8" />
        </button>

        {/* Video Container */}
        <div className={`relative bg-black rounded-lg overflow-hidden shadow-2xl ${
          isVertical 
            ? 'aspect-[9/16] max-w-md mx-auto' 
            : 'aspect-video w-full'
        }`}>
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-gray-900">
              <div className="flex flex-col items-center space-y-4">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2" style={{ borderColor: '#f97316' }}></div>
                <p className="text-white text-sm">Chargement de la vidéo...</p>
              </div>
            </div>
          )}
          
          <iframe
            src={embedUrl}
            title={project.title}
            className="w-full h-full"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            onLoad={() => setIsLoading(false)}
          />
        </div>

        {/* Video Info */}
        <div className="mt-4 text-center">
          <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
          <p className="text-gray-300 text-sm max-w-2xl mx-auto">{project.description}</p>
          <div className="flex items-center justify-center space-x-4 mt-3">
            <span className="text-gray-400 text-xs">{project.category}</span>
            <span className="text-gray-400 text-xs">•</span>
            <span className="text-gray-400 text-xs">{project.date}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPlayer;